import chroma from "chroma-js";

const generateColors = (numColors) => {
  return chroma
    .scale("Spectral")
    .mode("lab")
    .colors(numColors)
    .map((color) => chroma(color).darken(1).hex());
};

// Generate 50 colors and store them in an array
export const COLORS = generateColors(15);

//console.log(COLORS); // Check the generated colors
